import React from 'react';
import {
  Link as RRLink,
  NavLink as RRNavLink,
} from 'react-router-dom';
import injectSheet from 'react-jss';

// import { compose } from 'shared/helpers';
import { BASE_COLOR } from 'shared/constants/colors';

import { mixClasses as cx } from 'helpers';


// TODO: Link should just be fw4
/*
 * Link
 */
let Link = ({
  href = null,
  classes: cn,
  type = 'accented',
  className,
  children,
  ...props,
}) => {
  const presetClass = cn[type] || cn.accented;

  // Maybe overloading this component isn't a good idea..?
  return (typeof href === 'string'
    ? <a
        href={href}
        className={cx(cn.base, presetClass, className)}
        target="_blank"
        {...props}
      >
        {children}
      </a>
    : <RRLink
        className={cx(cn.base, presetClass, className)}
        {...props}
      >
        {children}
      </RRLink>
  );
};

const fancyUnderline = {
  backgroundSize: '100% 1px',
  backgroundImage: `linear-gradient(180deg, currentColor 100%, white 0)`,
  backgroundRepeat: 'repeat-x',
  backgroundPosition: 'left 93%',
};

Link = injectSheet({
  base: {
    transition: 'all 200ms ease',
  },
  basic: {
    backgroundPosition: 'left 110%',
    '&:hover': {
      ...fancyUnderline,
    }
  },
  accented: {
    color: BASE_COLOR.blue,
    borderTop: '2px solid transparent',
    borderBottom: '2px solid transparent',
    '&:hover': {
      borderBottom: `2px solid ${BASE_COLOR.lightBlue}`,
    },
  },
  intext: {
    backgroundSize: '100% 2px',
    backgroundImage: `linear-gradient(180deg, ${BASE_COLOR.caretBlue} 100%, white 0)`,
    backgroundRepeat: 'repeat-x',
    backgroundPosition: 'left 100%',
  },
  muted: {
    color: BASE_COLOR.lightGray,
    '&:hover': {
      color: BASE_COLOR.blue,
    },
  },
  footer: {
    color: BASE_COLOR.silver,
    '&:hover': {
      color: BASE_COLOR.white,
    },
  },
  // NOTE: Same as TextButton, abstract out?
  disabled: {
    color: BASE_COLOR.lightGray,
    pointerEvents: 'none',
    // textShadow: '0px 1px 0px rgba(255,255,255,.3), 0px -1px 0px rgba(175,175,175,.7)',
    '&:hover': {
      color: BASE_COLOR.lightGray,
      cursor: 'not-allowed',
    },
  },
})(Link);



/*
 * NavLink
 */
let NavLink = ({
  classes: cn,
  type = 'light',
  className = null,
  style = {},
  ...props,
}) => {
  // XXX(tyu): Not really using different types..
  // all 'light' for now.
  const normalStateColorCls = {
    light: 'silver',
    dark: 'gray',
  }[type];

  const activeStateColorStyle = {
    light: BASE_COLOR.black,
    dark: BASE_COLOR.white,
  }[type];

  return (
    <RRNavLink
      className={cx(cn.base, normalStateColorCls, "moa-ff-sans", className)}
      style={style}
      activeStyle={{color: activeStateColorStyle}}
      {...props}
    />
  );
};
NavLink = injectSheet({
  base: {
    fontSize: '14px',
    transition: 'all 200ms ease',
    '&:hover': {
      color: BASE_COLOR.black,
    },
  },
})(NavLink);


export {
  Link,
  NavLink,
};



// WEBPACK FOOTER //
// ./src/components/elems/Link.js